"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkInParagraph = exports.linkContainerClassName = exports.linkClassName = exports.Link = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Link.css");
var _useMergedRef = require("@cbhq/cds-common/hooks/useMergedRef");
var _ButtonOrLink = require("../system/ButtonOrLink");
var _linaria = require("../utils/linaria");
var _TextBody = require("./TextBody");
var _TextCaption = require("./TextCaption");
var _TextHeadline = require("./TextHeadline");
var _TextInherited = require("./TextInherited");
var _TextLabel = require("./TextLabel1");
var _TextLabel2 = require("./TextLabel2");
var _TextLegal = require("./TextLegal");
var _TextTitle = require("./TextTitle1");
var _TextTitle2 = require("./TextTitle2");
var _TextTitle3 = require("./TextTitle3");
var _TextTitle4 = require("./TextTitle4");
const _excluded = ["accessibilityLabel", "children", "to", "openInNewWindow", "testID", "rel", "renderContainer", "variant", "onPress", "color", "mono", "className", "underline"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const linkClassName = 'cds-link';
exports.linkClassName = linkClassName;
const linkContainerClassName = `${linkClassName}--container`;
exports.linkContainerClassName = linkContainerClassName;
const link = "cds-link-l17zyfmx";

// Used to enforce underlines when nested in a paragraph tag
const linkInParagraph = "cds-linkInParagraph-l1o37mk";
exports.linkInParagraph = linkInParagraph;
const TYPOGRAPHY_MAP = {
  body: _TextBody.TextBody,
  caption: _TextCaption.TextCaption,
  headline: _TextHeadline.TextHeadline,
  label1: _TextLabel.TextLabel1,
  label2: _TextLabel2.TextLabel2,
  title1: _TextTitle.TextTitle1,
  title2: _TextTitle2.TextTitle2,
  title3: _TextTitle3.TextTitle3,
  title4: _TextTitle4.TextTitle4,
  legal: _TextLegal.TextLegal,
  inherit: _TextInherited.TextInherited
};
const Link = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function Link(_ref, ref) {
  let accessibilityLabel = _ref.accessibilityLabel,
    children = _ref.children,
    to = _ref.to,
    _ref$openInNewWindow = _ref.openInNewWindow,
    openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow,
    testID = _ref.testID,
    rel = _ref.rel,
    renderContainer = _ref.renderContainer,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'inherit' : _ref$variant,
    onPress = _ref.onPress,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    mono = _ref.mono,
    className = _ref.className,
    underline = _ref.underline,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const linkRef = (0, _react.useRef)(null);
  const TextComponent = TYPOGRAPHY_MAP[variant];
  const mergedRef = (0, _useMergedRef.useMergedRef)(ref, linkRef);
  const enhancedProps = Object.assign({
    'aria-label': accessibilityLabel,
    'data-testid': testID,
    className: (0, _linaria.cx)(linkClassName, link, className),
    onClick: onPress,
    ref: mergedRef,
    href: to,
    rel,
    target: openInNewWindow ? '_blank' : undefined,
    children: /*#__PURE__*/_react.default.createElement(TextComponent, {
      as: "span",
      className: linkContainerClassName,
      color: color,
      mono: mono,
      underline: underline
    }, children)
  }, props);
  return renderContainer ? renderContainer(enhancedProps) : /*#__PURE__*/_react.default.createElement(_ButtonOrLink.ButtonOrLink, enhancedProps);
}));
exports.Link = Link;